import { Text } from '@wartek-id/text-v1'

import CardPenilaianKinerjaStep from 'app/KinerjaDinasPage/components/CardPenilaianKinerjaStep'

import type { FC } from 'react'

interface CardPenilaianKinerjaStepsProps {}

const CardPenilaianKinerjaSteps: FC<CardPenilaianKinerjaStepsProps> = ({}) => {
  return (
    <>
      <section className="bg-white border rounded-lg border-subdued p-6 space-y-3">
        <Text variant="heading-sm" className="text-black">
          Langkah-langkah Pelaksanaan Kinerja
        </Text>

        <div className="flex flex-row items-start gap-9">
          <CardPenilaianKinerjaStep
            title="Pantau status Praktik Kinerja dan Perilaku Kinerja"
            description="Beri himbauan ke Tim Kerja jika tidak sesuai ekspektasi."
          />
          <CardPenilaianKinerjaStep
            title="Lanjut ke Penetapan Predikat Kinerja"
            description="Anda dapat mulai tetapkan untuk yang statusnya sudah selesai.."
            withIcon
          />
        </div>
      </section>
    </>
  )
}
export default CardPenilaianKinerjaSteps
